import {
  paymentTypesService,
  type PaymentType,
  type ProductType,
} from '@/services';
import { useQuery } from '@tanstack/react-query';

export function usePaymentTypes(productType: ProductType | undefined) {
  return useQuery<PaymentType[], Error>({
    queryKey: ['payment-types', productType],
    queryFn: async () => {
      if (!productType) {
        throw new Error('Tipo de produto não informado');
      }

      const response = await paymentTypesService.getPaymentTypes(productType);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar tipos de pagamento'
        );
      }

      return response.data;
    },
    enabled: !!productType,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}
